import "./LabRoleSelectionComponent.scss";
import DialogComponent from "../dialog/dialogComponent";
import ButtonComponent from "../core/button/ButtonComponent";
import React, {useCallback} from "react";
import {LabRoleType} from "../../models/lab.model";
import {CommonService} from "../../services";

interface LabRoleSelectionComponentProps {
    isOpen: boolean;
    onLabSelection: (labType: LabRoleType) => void;
    currentLabRole?: LabRoleType;
    onClose: () => void;
    isLoading?: boolean;
}

const labRoles = CommonService._staticData.labRoles;
const LabRoleSelectionComponent = (props: LabRoleSelectionComponentProps) => {
    const {isOpen, onLabSelection, currentLabRole, onClose, isLoading} = props;

    const handleLabRoleType = useCallback((labType: LabRoleType) => {
        if (onLabSelection) {
            onLabSelection(labType)
        }
    }, [onLabSelection])

    return (
        <DialogComponent
            open={isOpen}
            disableEscKeyClose={true}
            disableBackdropClose={true}
            onClose={() => {
                onClose();
            }}
            direction={"down"}
            maxWidth={"xs"}
            isShowCancel={true}
            className={'labRoleSelection-component'}
        >
            <div className="lab-confirmation-dialog-container">
                <div className="lab-confirmation-dialog-title">Select Lab Functionality</div>
                <div className="lab-confirmation-dialog-title-and-description">
                    {/*<div className="confirmation-dialog-sub-title">{config?.confirmationSubTitle}</div>*/}
                    <div className="lab-confirmation-dialog-sub-description">
                        Please select the role of this lab in the system. This will determine how the lab handles
                        samples.
                    </div>
                </div>
                <div className="lab-confirmation-dialog-sub-actions">
                    {labRoles.map(({title, code}) => (
                        <ButtonComponent
                            key={code}
                            handleClick={() => handleLabRoleType(code)}
                            disabled={currentLabRole === code||isLoading}
                            color={'primary'}
                            fullWidth={true}
                            variant={"outlined"}
                        >
                            {title}
                        </ButtonComponent>
                    ))}
                </div>
            </div>
        </DialogComponent>
    );

};

export default LabRoleSelectionComponent;
